import React from 'react'
import { Settings, Clock, AlertCircle, Download } from 'lucide-react'
import { NOTIFICATION_SETTINGS } from './../Common/profileConstants'

export const SettingsTab = () => {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Account Settings</h2>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Security Settings */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200/50 p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-6">Security & Privacy</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
              <div>
                <p className="font-semibold text-gray-900">Two-Factor Authentication</p>
                <p className="text-sm text-gray-600">Add an extra layer of security</p>
              </div>
              <button className="px-4 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-all duration-200 text-sm font-medium">
                Enable
              </button>
            </div>
            
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
              <div>
                <p className="font-semibold text-gray-900">Change Password</p>
                <p className="text-sm text-gray-600">Update your account password</p>
              </div>
              <button className="px-4 py-2 text-teal-600 hover:text-teal-700 hover:bg-teal-50 rounded-lg transition-all duration-200 text-sm font-medium">
                Update
              </button>
            </div>
            
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
              <div>
                <p className="font-semibold text-gray-900">Login Sessions</p>
                <p className="text-sm text-gray-600">Manage your active sessions</p>
              </div>
              <button className="px-4 py-2 text-gray-600 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-all duration-200 text-sm font-medium">
                View
              </button>
            </div>
          </div>
        </div>

        {/* Notification Settings */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200/50 p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-6">Notifications</h3>
          <div className="space-y-4">
            {NOTIFICATION_SETTINGS.map((setting, index) => (
              <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                <div>
                  <p className="font-semibold text-gray-900">{setting.title}</p>
                  <p className="text-sm text-gray-600">{setting.desc}</p>
                </div>
                <div className={`w-12 h-6 rounded-full transition-all duration-200 ${setting.enabled ? 'bg-teal-500' : 'bg-gray-300'}`}>
                  <div className={`w-5 h-5 bg-white rounded-full shadow-sm transition-all duration-200 transform ${setting.enabled ? 'translate-x-6 mt-0.5' : 'translate-x-0.5 mt-0.5'}`}></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Data & Privacy */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200/50 p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-6">Data & Privacy</h3>
          <div className="space-y-4">
            <button className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-all duration-200">
              <div className="text-left">
                <p className="font-semibold text-gray-900">Download Your Data</p>
                <p className="text-sm text-gray-600">Get a copy of your account data</p>
              </div>
              <Download className="w-5 h-5 text-gray-400" />
            </button>
            
            <button className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-all duration-200">
              <div className="text-left">
                <p className="font-semibold text-gray-900">Privacy Settings</p>
                <p className="text-sm text-gray-600">Control who can see your information</p>
              </div>
              <Settings className="w-5 h-5 text-gray-400" />
            </button>
          </div>
        </div>

        {/* Danger Zone */}
        <div className="bg-white rounded-2xl shadow-lg border border-red-200/50 p-6">
          <h3 className="text-lg font-bold text-red-600 mb-6">Danger Zone</h3>
          <div className="space-y-4">
            <button className="w-full flex items-center justify-between p-4 bg-red-50 rounded-xl hover:bg-red-100 transition-all duration-200">
              <div className="text-left">
                <p className="font-semibold text-red-700">Deactivate Account</p>
                <p className="text-sm text-red-600">Temporarily disable your account</p>
              </div>
              <Clock className="w-5 h-5 text-red-400" />
            </button>
            
            <button className="w-full flex items-center justify-between p-4 bg-red-50 rounded-xl hover:bg-red-100 transition-all duration-200">
              <div className="text-left">
                <p className="font-semibold text-red-700">Delete Account</p>
                <p className="text-sm text-red-600">Permanently remove your account</p>
              </div>
              <AlertCircle className="w-5 h-5 text-red-400" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
